import { SnackbarVariant } from '@eas/common-web';
import { MessageType } from './message-type';

const LOGIN: MessageType<
  'NO_SUCH_USER' | 'WRONG_PASSWORD' | 'DUPLICATE_ACCOUNT' | 'ERROR'
> = {
  NO_SUCH_USER: [
    'Uživatel s tímto přihlašovacím jménem neexistuje.',
    SnackbarVariant.ERROR,
  ],
  WRONG_PASSWORD: ['Zadané heslo je nesprávné.', SnackbarVariant.ERROR],
  DUPLICATE_ACCOUNT: ['Účet byl zablokován.', SnackbarVariant.ERROR],
  ERROR: ['Přihlášení selhalo.', SnackbarVariant.ERROR],
};

export default { LOGIN };
